import { UserAccountFacade } from '@spartacus/user/account/root';
import { Provider } from '@angular/core';
import { CustomUserAccountService } from '../services/user-account.service';
import { UserAccountService } from '@spartacus/user/account/core';

export const customFacadeProviders: Provider[] = [
  UserAccountService,
  {
    provide: UserAccountFacade,
    useExisting: CustomUserAccountService,
  },
];
